import React, { Component } from 'react'

import FlagIcon from '@mui/icons-material/Flag'
import { Box, Tooltip } from '@mui/material'

import { CampaignCountries } from 'components/campaigns'
import CustomerSelect from 'components/customer/CustomerSelect'
import { FormDatePicker, FormSelect, FormTextField } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { useCampaignDerivedFields } from 'hooks/useCampaignDerivedFields'
import { assignableUsersOptions } from 'models/campaign-model'
import { CPM_OPTIONS, REGIONS } from 'models/campaign-review-model'
import { campaignChangedCustomerWarnings } from 'validators/campaign-edit'
import { campaignReviewDataValidator } from 'validators/campaign-review'

type DataReviewFormProps = {
  handleSubmit: (...args: any[]) => any
  initialValues: Record<string, any>
  onSubmit: (...args: any[]) => any
}

class DataReviewForm extends Component<DataReviewFormProps> {
  getConfig = () => [
    {
      title: 'Warnings',
      render: this.renderWarnings,
    },
    {
      title: 'Campaign name',
      render: () => <FormTextField name="title" />,
    },
    {
      title: 'Customer',
      render: () => <CustomerSelect name="customer" />,
    },
    {
      title: 'Countries',
      render: ({ countries }: any) => <CampaignCountries countries={countries} />,
    },
    {
      title: 'URL',
      render: () => <FormTextField name="url" />,
    },
    {
      title: 'Start date',
      render: () => <FormDatePicker name="startDate" />,
    },
    {
      title: 'End date',
      render: () => <FormDatePicker name="endDate" />,
    },
    {
      title: 'Currency',
      field: 'currency',
    },
    {
      title: 'Estimated Total Budget',
      render: () => <FormTextField name="totalBudget" type="number" />,
    },
    {
      title: 'Daily Budget',
      render: () => <FormTextField name="dailyBudget" type="number" />,
    },
    {
      title: 'CPM',
      render: () => <FormSelect name="cpm" options={CPM_OPTIONS} />,
    },
    {
      title: 'Goal impressions',
      render: () => <FormTextField name="goalImpressions" type="number" />,
    },
    {
      title: 'Goal RTB impressions',
      render: () => <FormTextField name="goalRtbImpressions" type="number" />,
    },
    {
      title: 'Extra views percent',
      render: () => <FormTextField disabled name="extraViewsPercent" type="number" />,
    },
    {
      title: 'Targets number',
      field: 'targetsNumber',
    },
    {
      title: 'Adform ID',
      render: () => <FormTextField name="adformId" type="number" />,
    },
    {
      title: 'Adform client (region)',
      render: () => <FormSelect allowEmpty={false} name="region" options={REGIONS} />,
    },
    {
      title: 'Assignee',
      render: () => <FormSelect name="assignedUserId" options={assignableUsersOptions} />,
    },
  ]

  renderWarnings = ({ usCampaign }: any) => (
    <div>
      {usCampaign && (
        <Box sx={{ display: 'inline-block', mr: '1rem', color: '#ff776f' }}>
          <Tooltip title="US campaign">
            <FlagIcon />
          </Tooltip>
        </Box>
      )}
    </div>
  )

  render() {
    const { handleSubmit, initialValues, onSubmit } = this.props

    return (
      <form id="campaignReview" onSubmit={handleSubmit(onSubmit)}>
        <DescriptionListTable config={this.getConfig()} data={initialValues} />
      </form>
    )
  }
}

const DataReviewFormWithDerivedFields = (props: any) => {
  useCampaignDerivedFields()
  return <DataReviewForm {...props} />
}

export default withForm({
  form: 'campaignReview',
  validate: campaignReviewDataValidator,
  warn: campaignChangedCustomerWarnings,
})(DataReviewFormWithDerivedFields)
